import QrScanStyles from 'shared/style/qrScanStyles'
import {getVideoStyles} from 'shared/utils/cameraUtils'

const QrScannerVideo = ({videoRef, isLoading, isInitializing}) => {
	return (
		<QrScanStyles.QrScanArea>
			<QrScanStyles.QrFrame>
				<QrScanStyles.VideoContainer>
					<video ref={videoRef} style={getVideoStyles()} />

					{isLoading && (
						<QrScanStyles.LoadingOverlay>
							<QrScanStyles.LoadingContent>
								<QrScanStyles.LoadingSpinner />
							</QrScanStyles.LoadingContent>
						</QrScanStyles.LoadingOverlay>
					)}

					{isInitializing && (
						<QrScanStyles.PlaceholderContent>
							<p>카메라 권한 요청 중...</p>
							<p style={{fontSize: '14px', marginTop: '8px', opacity: 0.7}}>
								브라우저에서 카메라 접근을 허용해주세요
							</p>
						</QrScanStyles.PlaceholderContent>
					)}
				</QrScanStyles.VideoContainer>
			</QrScanStyles.QrFrame>
		</QrScanStyles.QrScanArea>
	)
}

export default QrScannerVideo
